const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="#000"
      fillOpacity={0.3}
      d="M8.592 4.932a.682.682 0 1 1-1.364 0 .682.682 0 0 1 1.364 0ZM6.546 7.489a.511.511 0 0 1 .512-.512H8.08a.511.511 0 0 1 .512.512v2.897h.511a.511.511 0 1 1 0 1.023H7.058a.511.511 0 0 1 0-1.023h.511V8h-.511a.511.511 0 0 1-.512-.511Z"
    />
    <path
      fill="#000"
      fillOpacity={0.3}
      d="M7.91.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM1.433 8a6.477 6.477 0 1 0 12.954 0A6.477 6.477 0 0 0 1.433 8Z"
    />
  </svg>
)
export default InfoIcon
